var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 13.1667H4.28333L10.8 6.65L9.85 5.7L3.33333 12.2167V13.1667ZM2 14.5V11.6667L10.8 2.88333C10.9333 2.76111 11.0806 2.66667 11.2417 2.6C11.4028 2.53333 11.5722 2.5 11.75 2.5C11.9278 2.5 12.1 2.53333 12.2667 2.6C12.4333 2.66667 12.5778 2.76667 12.7 2.9L13.6167 3.83333C13.75 3.95556 13.8472 4.1 13.9083 4.26667C13.9694 4.43333 14 4.6 14 4.76667C14 4.94444 13.9694 5.11389 13.9083 5.275C13.8472 5.43611 13.75 5.58333 13.6167 5.71667L4.83333 14.5H2ZM10.3167 6.18333L9.85 5.7L10.8 6.65L10.3167 6.18333Z",
    fill: "#0066D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen_icon.39b92e49e109a52ec89955b0b2195975.svg";
export { ForwardRef as ReactComponent };